// extracted by mini-css-extract-plugin
export var billingAddress = "_rl-g";
export var contactInfo = "_rl-d";
export var customerInfoContainer = "_rl-c";
export var customerInfoContainerMobile = "_rl-h";
export var customerInfoRow = "_rl-a";
export var customerInfoSection = "_rl-b";
export var fullWidthDividerMobile = "_rl-i";
export var imageContainer = "_rl-1";
export var paymentMethod = "_rl-e";
export var priceText = "_rl-6";
export var priceTextMobile = "_rl-7";
export var product = "_rl-0";
export var productImage = "_rl-2";
export var productInfo = "_rl-4";
export var productMobile = "_rl-9";
export var productTitle = "_rl-8";
export var quantityBadge = "_rl-3";
export var quantityText = "_rl-5";
export var shippingAddress = "_rl-f";